import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  profileActivity: {
    padding: `0 ${theme.spacing.space20}px`,
    gap: theme.spacing.space8,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    paddingBottom: 8,
  },
  statItem: {
    display: "flex",
    justifyContent: "space-between",
    background: theme.colors.background6,
    color: theme.colors.text1,
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    borderRadius: theme.spacing.space12,
    alignItems: "center",
    height: 65,
  },
  label: { display: "flex", alignItems: "center", gap: theme.spacing.space12 },
  value: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
  },
  img: {
    width: 40,
    height: 65,
    borderRadius: 8,
  },
}));
